import {paddingLeft} from "../strings";

export const formatDateUtc_v2 = (date) => {
    return (
        date.getUTCFullYear() + "-" +
        paddingLeft(date.getUTCMonth()+1) + "-" +
        paddingLeft(date.getUTCDate()) + " " +
        paddingLeft(date.getUTCHours()) + ":" +
        paddingLeft(date.getUTCMinutes()) + ":" +
        paddingLeft(date.getUTCSeconds())
    );
};
